// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getIconPath, getLocator } from '@tcp/core/src/utils';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Button from '@tcp/core/src/components/common/atoms/Button';
import Image from '@tcp/core/src/components/common/atoms/Image';
import style from '../styles/FilterPill.style';

const FilterPill = (props) => {
  const { className, labels, pillImg, handleClick } = props;
  return (
    <div className={`${className} filter-pill`}>
      <Button
        buttonVariation="fixed-width"
        type="button"
        className="pill-button"
        onClick={handleClick}
        fill="WHITE"
      >
        <BodyCopy className="pill-text">{labels}</BodyCopy>
        {pillImg && (
          <Image
            src={getIconPath(pillImg)}
            alt="pill image"
            className={`pill-image ${pillImg}`}
            data-locator={getLocator(pillImg)}
          />
        )}
      </Button>
    </div>
  );
};

FilterPill.propTypes = {
  className: PropTypes.string,
  labels: PropTypes.string,
  pillImg: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
};

FilterPill.defaultProps = {
  className: '',
  labels: '',
  pillImg: '',
};

export default withStyles(FilterPill, style);
export { FilterPill as FilterPillVanilla };
